import React, { useEffect } from "react";
import { Button } from "react-bootstrap";

export const WorkspaceGroupTableRow = (props) => {
  const { activeId, group, changeActiveId } = props;
  const rowColor = activeId === group.group_id ? "blue" : "";

  useEffect(() => {}, [activeId]);

  return (
    <tr className="border-bottom" style={{ color: rowColor }}>
      <td className="fw-bold">
        <div className="d-flex align-items-center">
          {group.group_name || ""}
        </div>
      </td>
      <td className="fw-bold">
        <div className="d-flex align-items-center">
          {group.group_description || ""}
        </div>
      </td>
      <td>
        <Button
          variant="primary"
          size="sm"
          onClick={() => changeActiveId(group.group_id)}
          style={{
            backgroundColor: "blue",
            color: "white",
            paddingTop: 1,
            paddingBottom: 1,
          }}>
          Config
        </Button>
      </td>
    </tr>
  );
};
